import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon, CheckIcon } from "lucide-react";
import { book, heroPoints } from "../data/book";
import { BookCover } from "./BookCover";
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-ink" data-id="element-63" data-mp="9luxafjjzvqk">
      <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 pt-16 pb-20 lg:grid-cols-[1.15fr_1fr] lg:px-10 lg:pt-24 lg:pb-28" data-id="element-64" data-mp="4lyswf6y22ah">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-65" data-mp="128z0cez35zzp">
          <p className="font-serif text-sm tracking-[0.3em] text-gold sm:text-base" data-id="element-66" data-mp="s9ghy2ytqm9r">
            A BOOK FOR FOUNDERS
          </p>
          <h1 className="mt-4 font-display text-6xl leading-[0.95] text-cream sm:text-7xl xl:text-8xl" data-id="element-67" data-mp="3d1ilrd3pdip0">
            The
            <br data-id="element-68" data-mp="381xjaspbqs7j" />
            Mentored
            <br data-id="element-69" data-mp="380w1849w55gb" />
            Founder
          </h1>

          <div aria-hidden="true" className="mt-8 flex items-center gap-3" data-id="element-70" data-mp="3j7zgfm2d3yi9">
            <span className="h-px w-36 bg-gold/50" data-id="element-71" data-mp="3o7ls3r2jl6oy" />
            <span className="h-[2px] w-12 bg-gold" data-id="element-72" data-mp="3o6ar1z0hed1j" />
          </div>

          <p className="mt-7 max-w-md font-serif text-2xl leading-snug text-cream/90" data-id="element-73" data-mp="39ausbgoyhsyt">
            {book.subtitle}.
          </p>

          <ul className="mt-7 space-y-3" data-id="element-74" data-mp="3e84mf9naissz">
            {heroPoints.map(point => <li key={point} className="flex items-center gap-3 text-cream/85" data-id="element-75" data-mp="30hhohjpct6xy">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-76" data-mp="358rfooqjwiby">
                  <CheckIcon className="h-3 w-3 text-ink" strokeWidth={3} data-id="element-77" data-mp="2qk3lomwcsgo4" />
                </span>
                {point}
              </li>)}
          </ul>

          <div className="mt-10 max-w-md" data-id="element-78" data-mp="2vj7uhcfd8cdx">
            <a href={book.preorderUrl} target="_blank" rel="noopener noreferrer" className="group flex w-full items-center justify-center gap-3 rounded-lg bg-gold px-8 py-5 text-lg font-bold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-79" data-mp="2hjf3dfzxfu5f">
              Pre-order free
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-80" data-mp="icromrj9an9r" />
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto w-full max-w-[300px] sm:max-w-[360px] lg:max-w-[420px]" data-id="element-81" data-mp="1b15qjidgu3ql">
          <BookCover data-id="element-82" data-mp="x0crckc7ykh5" />
        </motion.div>
      </div>
    </section>;
}